export default "__VITE_ASSET__DHqsfyUW__"